import React from 'react'
import { useSharedStyles } from '../../Settings/useSharedStyles'
import { Box, Typography } from '@mui/material'
import { ShoppingCard } from '@/shared/ui/Icons'
import { DataLine } from '../../../components/settings/components/DataLine'
import { useTranslation } from 'react-i18next'

const SubscriptionSection = () => {
    const { t: translate } = useTranslation()
    const {
        titleStyle,
        titleContainer,
        sectionStyle,
        iconContainer,
        dataContainer,
    } = useSharedStyles()
    return (
        <Box sx={sectionStyle}>
            <Box sx={titleContainer}>
                <Box sx={iconContainer}>
                    <ShoppingCard />
                </Box>
                <Typography ml="24px" sx={titleStyle}>
                    {translate('package')}
                </Typography>
            </Box>
            <Box sx={dataContainer}>
                <DataLine fieldName="packageName" value="Premiun XXL" />
                <DataLine fieldName="price" value="60zł / miesiąc" />
                <DataLine fieldName="monthPayData" value="01.01.2024" />
                <DataLine fieldName="paymentMethod" value="986653" />
                <DataLine fieldName="expiredDate" value="none" />
            </Box>
        </Box>
    )
}

export default SubscriptionSection
